import { render, staticRenderFns } from "./InsightsCardsBlock.vue?vue&type=template&id=8b4e4862&scoped=true&"
import script from "./InsightsCardsBlock.vue?vue&type=script&lang=js&"
export * from "./InsightsCardsBlock.vue?vue&type=script&lang=js&"
import style0 from "./InsightsCardsBlock.vue?vue&type=style&index=0&id=8b4e4862&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4e4862",
  null
  
)

export default component.exports